var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.33 18.96H4.17a3.13 3.13 0 0 1-3.13-3.13V1.67c0-.35.29-.63.63-.63s.62.28.62.63v14.16c0 1.04.84 1.88 1.88 1.88h14.16c.35 0 .63.28.63.62 0 .35-.28.63-.63.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M4.17 14.8a.6.6 0 0 1-.41-.16.63.63 0 0 1-.07-.88l3.83-4.47a2.3 2.3 0 0 1 3.35-.13l.8.79q.31.3.77.3t.75-.36l3.83-4.47c.22-.25.61-.29.88-.06.26.22.3.61.07.88l-3.83 4.47a2.3 2.3 0 0 1-3.36.13l-.78-.79q-.32-.31-.78-.3-.44 0-.75.36l-3.82 4.46a.7.7 0 0 1-.48.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiagram);
export default ForwardRef;